import { render, staticRenderFns } from "./PreviewVideoResume.vue?vue&type=template&id=abc6d9e4&scoped=true"
import script from "./PreviewVideoResume.vue?vue&type=script&lang=js"
export * from "./PreviewVideoResume.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideoResume.vue?vue&type=style&index=0&id=abc6d9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc6d9e4",
  null
  
)

export default component.exports